import { call, put, takeLatest } from "redux-saga/effects";
import { select } from "redux-saga/effects";

import { showErrorMessage } from "../../../redux-saga/redux/toast";
import {
  getFavMatchSuccess,
  getLiveMatchesStart,
  getMatchesFailure,
  getMatchesSuccess,
  getPreMatchesStart,
  getReconnectionStart
} from "../../redux/matches";
import { joinRooms } from "../../../container/SportsBookNode/utils/common/functions";
import MatchService from "../../services/matches";
import FavouriteService from "../../services/favourites";
import {
  liveSocket,
  dashboardLiveMatchEvent,
  dashboardPreMatchEvent,
  preLiveSocket,
  sponserLiveMatchEvent,
  sponserPreMatchEvent,
  topDashboardLiveMatchEvent,
  topDashboardPreMatchEvent,
  preMatchSingleEvent,
  liveMatchSingleEvent,
  betslipLiveMatchEvent,
  betslipPreMatchEvent
} from "../../../container/SportsBookNode/utils/common/socket.config";
function* matchesWatcher() {
  yield takeLatest(getPreMatchesStart.type, matchesWorker);
  yield takeLatest(getLiveMatchesStart.type, matchesWorker);
  yield takeLatest(getReconnectionStart.type, socketReconnectionWorker);
}

function* matchesWorker(action) {
  try {
    let { data, error } = !action?.payload?.isFavourite
      ? yield call(MatchService.getMatches, action.payload)
      : yield call(FavouriteService.getFavouritesMatches, action.payload);

    if (
      action?.payload?.isFavourite &&
      parseInt(data?.totalPage) !== 0 &&
      parseInt(data?.currentPage) > parseInt(data?.totalPage) &&
      !data?.matchList?.length
    ) {
      const resData = yield call(FavouriteService.getFavouritesMatches, {
        ...action.payload,
        page: parseInt(action.payload.page) - 1
      });
      data = resData?.data;
      error = resData?.error;
    }
    if (data) {
      if (action?.payload?.isFavourite) {
        yield put(
          getFavMatchSuccess({
            data,
            isLive: action.payload.isLive,
            sportsId: action.payload.sportsId
          })
        );
      } else {
        yield put(
          getMatchesSuccess({
            data,
            isLive: action.payload.isLive,
            sportsId: action.payload.sportsId
          })
        );
      }
      if (error) {
        yield put(showErrorMessage({ msg: error }));
        yield put(getMatchesFailure());
      }
    }
  } catch (error) {
    yield put(getMatchesFailure());
    yield put(showErrorMessage({ msg: error }));
  }
  //   finally {
  //     if (yield cancelled()) {
  //     }
  //   }
}

function* socketReconnectionWorker(action) {
  try {
    const { livematches, prelivematches } = yield select(
      (state) => state.sportbook?.matches
    );

    const extraMarkets = yield select(
      (state) => state.sportbook.extraMarkets.matchDetails
    );

    const { sponsoredEvents } = yield select(
      (state) => state.sportbook.topSponsoredEvent
    );

    const bets = yield select((state) => state.sportbook.betslip.bets);

    const topMatches = yield select(
      (state) => state.sportbook.topMatches?.matches
    );

    if (livematches?.matches?.length || prelivematches?.matches?.length) {
      const liveMatchData = livematches?.matches;
      const preLiveMatchData = prelivematches?.matches;
      const matches = [...liveMatchData, ...preLiveMatchData];

      joinRooms({
        matches: matches,
        liveSocket,
        preLiveSocket,
        liveEvent: dashboardLiveMatchEvent,
        preLiveEvent: dashboardPreMatchEvent,
        ...action.payload
      });
    }

    if (sponsoredEvents?.matchList?.length) {
      joinRooms({
        matches: sponsoredEvents?.matchList,
        liveSocket,
        preLiveSocket,
        liveEvent: sponserLiveMatchEvent,
        preLiveEvent: sponserPreMatchEvent,
        ...action.payload
      });
    }

    if (topMatches?.length) {
      joinRooms({
        matches: topMatches,
        liveSocket,
        preLiveSocket,
        liveEvent: topDashboardLiveMatchEvent,
        preLiveEvent: topDashboardPreMatchEvent,
        ...action.payload
      });
    }

    if (extraMarkets && extraMarkets?.matchId) {
      joinRooms({
        matches: [extraMarkets],
        liveSocket,
        preLiveSocket,
        liveEvent: liveMatchSingleEvent,
        preLiveEvent: preMatchSingleEvent,
        ...action.payload
      });
    }

    if (bets?.length) {
      joinRooms({
        matches: bets,
        liveSocket,
        preLiveSocket,
        liveEvent: betslipLiveMatchEvent,
        preLiveEvent: betslipPreMatchEvent,
        ...action.payload
      });
    }
  } catch (error) {
    yield put(showErrorMessage({ msg: error.message }));
  }
}

export default matchesWatcher;
